import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap"

import InvoiceOrders from "../../../components/Common/GenerateInvoice"
import Breadcrumbs from "components/Common/Breadcrumb"
import IH from "components/Common/InvoiceHistory"

const InvoiceHistory = () => {
  const [user, setUser] = useState(null)

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const storedUser = JSON.parse(localStorage.getItem("authUser"))?.user
        if (storedUser) {
          setUser(storedUser)
        }
      } catch (err) {
        console.error("Error parsing user from localStorage", err)
      }
    }

    fetchUser()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Invoice History | Invoice History Section</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title="Invoice History" breadcrumbItem="Invoice History" />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  {user ? <IH isOpen={true} orderObject={user} user={true} /> : <p>Loading...</p>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default InvoiceHistory
